import { useMap, useMapEvents } from 'react-leaflet';
import { LatLng } from 'leaflet';
import { Dispatch, SetStateAction } from 'react';

export function SaveMapPositionComponent({
  setZoomLevel,
  setCenterPosition,
}: {
  setZoomLevel: Dispatch<SetStateAction<number>>;
  setCenterPosition: Dispatch<SetStateAction<LatLng>>;
}) {
  const map = useMap();

  useMapEvents({
    zoomend: () => {
      const currentZoomLevel = map.getZoom();
      if (!currentZoomLevel) {
        return;
      }
      setZoomLevel(currentZoomLevel);
    },
    moveend: () => {
      const currentCenterPosition = map.getCenter();
      if (!currentCenterPosition) {
        return;
      }
      setCenterPosition(currentCenterPosition);
    },
  });

  return null;
}
